/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Nav_LabelInputs */

const en_hotel_nav_label = /** @type {(inputs: Hotel_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const zh_hotel_nav_label = /** @type {(inputs: Hotel_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主导航`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Hotel_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const hotel_nav_label = /** @type {((inputs?: Hotel_Nav_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Nav_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hotel_nav_label(inputs)
	return zh_hotel_nav_label(inputs)
});
export { hotel_nav_label as "hotel.nav_label" }